<script setup lang="ts">
import { inject, ref } from "vue";

import routeManager from "@/router/route-manager";
import { labelServiceSymbol } from "@/plugins/LabelServicePlugin";

import { ConfigurationError } from "@/types/errors";
import type { LabelService } from "@/composables/label-service";
import type { SimpleRoutingParams } from "@/types/routing";

const labelService = inject< LabelService >( labelServiceSymbol ) as LabelService;

const social = routeManager.socialNavigation();
const facebook = ref< SimpleRoutingParams >( findRoutingConfig( social, 'lblFacebook' ) );
const x = ref< SimpleRoutingParams >( findRoutingConfig( social, 'lblX' ) );
const instagram = ref< SimpleRoutingParams >( findRoutingConfig( social, 'lblInstagram' ) );
const youTube = ref< SimpleRoutingParams >( findRoutingConfig( social, 'lblYouTube' ) );
const discord = ref< SimpleRoutingParams >( findRoutingConfig( social, 'lblDiscord' ) );

function findRoutingConfig( source: SimpleRoutingParams[], itemKey: string ): SimpleRoutingParams {
  const config = source.find( ( { key } ) => key === itemKey );
  if ( !config ) {
    throw new ConfigurationError(
        `The route configuration with key '${ itemKey }' is not currently defined. Update the definition in routeManager and rebuild.`
    )
  }

  return config;
}

function hideMenuOnBlur( event: MouseEvent ) {
  if ( event.target ) {
    ( event.target as Element ).removeAttribute( "open" );
  }
}

function showMenuOnFocus( event: Event ) {
  if ( event.target ) {
    ( event.target as Element ).setAttribute( "open", "" );
  }
}
</script>

<template>
  <details @mouseenter="showMenuOnFocus" @mouseleave="hideMenuOnBlur" class="header-menu dropdown dropdown-end dropdown-hover">
    <summary class="btn btn-sm btn-ghost text-base">
      <i class="text-primary pi pi-share-alt lg:inline"></i>
      <span class="hidden lg:inline items-center gap-2 text-base">{{ labelService.label( 'lblSocial' ) }}</span>
    </summary>
    <ul class="menu dropdown-content w-min-58" @click="hideMenuOnBlur">
      <li>
        <a :href="facebook.path" target="_blank">
          <i class="text-primary pi" :class="facebook.icon"></i><span class="ml-2 text-base">{{ labelService.label( facebook.key ) }}</span>
        </a>
      </li>
      <li>
        <a :href="x.path" target="_blank">
          <i class="text-primary pi" :class="x.icon"></i><span class="ml-2 text-base">{{ labelService.label( x.key ) }}</span>
        </a>
      </li>
      <li>
        <a :href="instagram.path" target="_blank">
          <i class="text-primary pi" :class="instagram.icon"></i><span class="ml-2 text-base">{{ labelService.label( instagram.key ) }}</span>
        </a>
      </li>
      <li>
        <a :href="youTube.path" target="_blank">
          <i class="text-primary pi" :class="youTube.icon"></i><span class="ml-2 text-base">{{ labelService.label( youTube.key ) }}</span>
        </a>
      </li>
      <li>
        <a :href="discord.path" target="_blank">
          <i class="text-primary pi" :class="discord.icon"></i><span class="ml-2 text-base">{{ labelService.label( discord.key ) }}</span>
        </a>
      </li>
    </ul>
  </details>
</template>
